import React from "react";
import "./Style.css";
import { Link } from "react-router-dom";
import FlashOffersData from "./FlashOffersData";
import ConstantHelper from "../../Helpers/ConstantHelper";

const FlashOffers = () => {
  return (
    <div className="marquee-list">
      <div className="news-title">
        <h5>Great Deals</h5>
      </div>
      <ul>
        {FlashOffersData?.map((item) => {
          if (item.chat) {
            return (
              <li key={item.id}>
                <a
                  href={ConstantHelper.getChatLink(
                    `*Hello TZ Creation Team*, I'm interested in the "${item.name}" offer. Please share the details.`
                  )}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.name}
                </a>
              </li>
            );
          }
          if (item.link) {
            return (
              <li key={item.id}>
                <Link to={item.link}>{item.name}</Link>
              </li>
            );
          }
          return (
            <li key={item.id} className="offer-static">
              {item.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default FlashOffers;
